enum SortDirection {
  ASCENDING = 'ascending',
  DESCENDING = 'descending'
}

export default SortDirection;
